
                import "css-modules://src_components_inputradio"
                export default {"Main":"_6446cd","Grid":"_100c4a","Legend":"_758475","Label":"_515ed2","Svg":"_45fd1d","PathCircle":"_8e785a","LabelText":"_df75c2","Input":"_dfc70c"}
            